
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#234652"}},[_c('path',{staticClass:"i-stroke",attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"m2 2 2.491 2.491m7.853 7.853L15 15m-6.5-1.5c-4.455 0-7-5-7-5 .792-1.449 1.836-2.836 3.167-3.834l7.56 7.577A6.46 6.46 0 0 1 8.5 13.5M7.164 3.65c.438-.1.886-.151 1.336-.15 4.454 0 7 5 7 5a11.6 11.6 0 0 1-1.374 1.994z"}}),_c('path',{staticClass:"i-Ellipse 1",attrs:{"d":"M7.077 7.119a1.985 1.985 0 1 0 2.807 2.807"}})])])
          )
        }
      }
    